<template>
  <BIParameterRuleForm />
</template>

<script>
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import BIParameterRuleForm from '@/components/BIControlPanel/BIParameterRuleForm/BIParameterRuleForm.vue';
import BiPanelRuleModule from '@/store/modules/bi-panel-rule/bi-panel-rule-module';

export default {
  name: 'BIParameterRuleFormPage',
  components: { BIParameterRuleForm },
  mixins: [AuthorityManagementMixin],
  async created() {
    if (!this.hasPermission('sdi_bi_panel_parameter_editar')) {
      this.$router.replace({ name: 'BIControlPanel' });
      return;
    }

    const { mode, ruleId } = this.$route.query;

    if (mode === 'edit' && ruleId) {
      const result = await BiPanelRuleModule.openEditForm(Number(ruleId));

      if (!result.success) {
        BiPanelRuleModule.closeForm();
        this.$router.replace({
          name: 'BIControlPanel',
          query: { tab: 'BIParameterRules' },
          params: { errorMessage: result.errorMessage },
        });
      }
    } else {
      BiPanelRuleModule.openCreateForm();
    }
  },
};
</script>
